import React, { useReducer } from "react";
import ParameterContext from "./parameterContext";
import ParameterReducer from "./parameterReducer";
import {
  TOGGLE_MODAL,
  SET_PAGE,
  SET_COLUMN_NAME,
  SET_FAVOURITE_TAB,
  SET_TRADATHON_LISTINGS_TAB,
  SET_TIME_IN_CHART,
  TOGGLE_VTRADING_MODAL,
  SET_VIRTUAL_TRADING_BUTTON,
  SET_ACTIVE_PORTFOLIO_PAGE,
  SET_ORDER_TYPE,
  SET_TRADATHON_RESULT_LISTING_TAB,
  SET_ACTIVE_ROOM_ID,
  TOGGLE_USER_ALERT_MODAL,
  TOGGLE_PUBLIC_CONTEST_MODAL,
} from "../types";

let activeRoomIdFromLocalStorage = localStorage.getItem("activeRoom")
  ? JSON.parse(localStorage.getItem("activeRoom")).rid
  : null;
const ParameterState = ({ children }) => {
  const initialState = {
    modal: false,
    page: 0,
    columnName: null,
    favouriteTab: "coins",
    listingTab: "upcoming",
    timeInChart: "ytd",
    vtradingModal: false,
    vtButton: "position",
    activePortfolio: 1,
    placeOrderType: "market",
    tradathonResultListingTab: "Edit Portfolio",
    activeRoomId: activeRoomIdFromLocalStorage,
    userAlertModal: false,
    publicContestModal: false,
  };
  const [state, dispatch] = useReducer(ParameterReducer, initialState);
  const toggleModal = () => {
    dispatch({ type: TOGGLE_MODAL });
  };
  const setPage = (p) => {
    dispatch({ type: SET_PAGE, payload: p });
  };
  const setColumnName = (name) => {
    dispatch({ type: SET_COLUMN_NAME, payload: name });
  };
  const setFavouriteTab = (tabName) => {
    dispatch({ type: SET_FAVOURITE_TAB, payload: tabName });
  };
  const setTradathonListingTab = (tabName) => {
    dispatch({ type: SET_TRADATHON_LISTINGS_TAB, payload: tabName });
  };
  const setTimeInChart = (time) => {
    dispatch({ type: SET_TIME_IN_CHART, payload: time });
  };
  const toggleVtradingModal = () => {
    dispatch({ type: TOGGLE_VTRADING_MODAL });
  };
  const setVtButton = (name) => {
    dispatch({ type: SET_VIRTUAL_TRADING_BUTTON, payload: name });
  };
  const setActivePortfolioPage = (active) => {
    dispatch({ type: SET_ACTIVE_PORTFOLIO_PAGE, payload: active });
  };
  const setOrderType = (data) => {
    dispatch({ type: SET_ORDER_TYPE, payload: data });
  };
  const setTradathonResultListingTab = (data) => {
    dispatch({ type: SET_TRADATHON_RESULT_LISTING_TAB, payload: data });
  };
  const setActiveRoomId = (data) => {
    dispatch({ type: SET_ACTIVE_ROOM_ID, payload: data });
  };
  const toggleUserAlertModal = () => {
    dispatch({ type: TOGGLE_USER_ALERT_MODAL });
  };
  const togglePublicContestModal = () => {
    dispatch({ type: TOGGLE_PUBLIC_CONTEST_MODAL });
  };
  return (
    <ParameterContext.Provider
      value={{
        toggleModal,
        setPage,
        setColumnName,
        setFavouriteTab,
        setTradathonListingTab,
        setTimeInChart,
        toggleVtradingModal,
        setVtButton,
        setActivePortfolioPage,
        setOrderType,
        setTradathonResultListingTab,
        modal: state.modal,
        columnName: state.columnName,
        page: state.page,
        favouriteTab: state.favouriteTab,
        listingTab: state.listingTab,
        timeInChart: state.timeInChart,
        vtradingModal: state.vtradingModal,
        vtButton: state.vtButton,
        activePortfolio: state.activePortfolio,
        placeOrderType: state.placeOrderType,
        tradathonResultListingTab: state.tradathonResultListingTab,
        activeRoomId: state.activeRoomId,
        setActiveRoomId,
        toggleUserAlertModal,
        userAlertModal: state.userAlertModal,
        togglePublicContestModal,
        publicContestModal: state.publicContestModal,
      }}
    >
      {children}
    </ParameterContext.Provider>
  );
};

export default ParameterState;
